/**
 * Legacy org-less `/automations`: automations live under the organization
 * (`/$org/automations`). Redirects to the last-picked org, or home.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { orgUrlSegment } from "../orgRouting";
import { readLastPickedOrgId } from "../state/orgs";

export const Route = createFileRoute("/automations")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
    const lastPickedOrgId = readLastPickedOrgId();
    if (!lastPickedOrgId) {
      throw redirect({ to: "/", replace: true });
    }
    throw redirect({
      to: "/$org/automations",
      params: { org: orgUrlSegment(lastPickedOrgId) },
      replace: true,
    });
  },
});
